export enum InsightCallSource {
  INSIGHT = "insight",
  PATTERN = "pattern",
}
